<div class="component">
  <div>
    <div class="title">
      <h2 class="title title-primary">Bem-vindo Empresa</h2>
      <p class="description description-primary">Selecione o que deseja fazer</p>
    </div>
    <div>
      <button class="btn btn-primary" [routerLink]="['/listarclientes']">Listar Clientes</button>  
      <button class="btn btn-second" [routerLink]="['/listarpedido']">Listar Pedidos</button>  
    </div>
    <div class="quit">
      <button class="btn-quit " [routerLink]="['/']">Sair</button> 
    </div>
  </div>
  
</div>


